export default __webpack_public_path__ + "static/media/privacy-policy-en-0.94429c8f.jpg";